
import {
  Badge,
} from '@chakra-ui/react';
import { Edit, Trash2 } from 'lucide-react';
import { TableColumn, TableAction, ActionHandler } from '@/components/section/EntityTableSection';
import { Speciality } from './api';
import { SpecialityAction } from './hooks/useSpecialityActions';
import RelativeTime from '@/components/ui/RelativeTime';

export const createSpecialityColumns = (): TableColumn<Speciality>[] => [
  {
    key: "id",
    title: "ID",
    variant: "id",
  },
  {
    key: "title", 
    title: "TITLE",
    variant: "primary",
  },
  {
    key: "is_shown",
    title: "VISIBILITY",
    render: (speciality) => (
      <Badge 
        size="sm" 
        colorPalette={speciality.is_shown ? 'green' : 'red'}
        variant="subtle"
      >
        {speciality.is_shown ? 'Shown' : 'Hidden'}
      </Badge>
    ),
  },
  {
    key: "created",
    title: "CREATED",
    render: (speciality) => (
      <RelativeTime date={speciality.created_at} />
    ),
  },
  {
    key: "updated",
    title: "UPDATED",
    render: (speciality) => (
      <RelativeTime date={speciality.updated_at} fallbackDate={speciality.created_at} />
    ),
  },
];

export const createSpecialityActions = (
  onAction: ActionHandler<Speciality, SpecialityAction>,
  isLoading: boolean
): TableAction<Speciality>[] => [
  {
    key: "edit",
    label: "Edit",
    icon: Edit,
    onClick: (entity) => onAction("edit", entity),
    disabled: isLoading,
  },
  {
    key: "delete",
    label: "Delete",
    icon: Trash2,
    onClick: (entity) => onAction("delete", entity),
    disabled: isLoading,
            colorPalette: "red",
  },
]; 